export const FETCH_TRANSLATIONS_START = 'FETCH_TRANSLATIONS_START';
export const FETCH_TRANSLATIONS_SUCCESS = 'FETCH_TRANSLATIONS_SUCCESS';
export const FETCH_TRANSLATIONS_FAIL = 'FETCH_TRANSLATIONS_FAIL';

export type TranslationActionTypes =
  typeof FETCH_TRANSLATIONS_START |
  typeof FETCH_TRANSLATIONS_SUCCESS |
  typeof FETCH_TRANSLATIONS_FAIL
;
